<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md6>

      <v-container>

        <v-card v-if="success" outlined class="mb-4">
          <v-card-text>
            <h2 class="text-h6 mb-2">Comprobante enviado</h2>
            <p class="body-2 mb-3">
              Tu comprobante fue recibido y quedó <strong>en revisión</strong>. Te notificaremos por email cuando
              sea aprobado o si necesitás reenviar otro archivo.
            </p>
            <div class="mb-3">
              <strong>Estado:</strong>
              <v-chip small :color="stateInfo.color" text-color="white" class="ml-1">
                {{ stateInfo.text }}
              </v-chip>
            </div>
            <div v-if="receiptUrl" class="mb-3">
              <v-btn :href="receiptUrl" target="_blank" small color="primary">
                Ver comprobante
              </v-btn>
            </div>
          </v-card-text>
        </v-card>

        <v-alert v-else-if="error" type="error" :value="true" class="mb-3">
          {{ error }}
        </v-alert>

        <div v-else>
          <div v-if="inscripcion && inscripcion.modalidad.evento && !isExpired && (!inscripcion.payment_receipt_path || inscripcion.state === 'pago_pendiente')">
            <v-alert :value="true" type="success">
              <p style="margin-bottom: 0;" class="headline">Paso 1 de 2</p>
            </v-alert>
            <p class="body-2 mb-1 mt-3">
              Hola {{ inscripcion.personas[0].nombre }} {{ inscripcion.personas[0].apellido }}, tu pre-inscripción a
              <strong>{{ inscripcion.modalidad.evento.nombre }}</strong> fue registrada correctamente.
            </p>

            <blockquote class="quote-payment-instruction">
              <p class="body-2 my-3">
                Asegura tu cupo en la carrera <strong>{{ inscripcion.modalidad.nombre }}</strong> realizando el pago y enviando el
                comprobante correspondiente.
              </p>
            </blockquote>
          </div>

          <v-card v-if="showTransferInstructions" outlined class="mb-3">
            <v-card-text>

              <div class="mb-">
                <div>
                  <h2 class="text-h6 mb-2">Instrucciones para transferir</h2>
                  <p class="body-2">Podés realizar la transferencia utilizando <strong>alias</strong> o
                    <strong>CBU/CVU</strong>.</p>
                  <div class="grey lighten-4 pa-3 rounded mb-3">
                    <p class="mb-1"><strong>Alias: </strong> <span class="success--text text--darken-1"></span> {{
                      inscripcion.modalidad.evento.bank_alias }}</p>
                    <p class="mb-1"><strong>CBU/CVU: </strong> <span class="primary--text text--darken-1">{{
                      inscripcion.modalidad.evento.bank_cbu }}</span></p>
                    <p class="mb-0"><strong>Titular: </strong>{{ inscripcion.modalidad.evento.bank_account_holder }}</p>
                    <p class="mb-0"><strong>MONTO: </strong>{{ paymentData.total }}</p>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-card v-if="inscripcion && hasReceipt" outlined class="mb-4">
            <v-card-text>
              <h2 class="text-h6 mb-3">Comprobante de pago</h2>
              <div class="mb-3">
                <strong>Estado:</strong>
                <v-chip small :color="stateInfo.color" text-color="white" class="ml-1">
                  {{ stateInfo.text }}
                </v-chip>
              </div>
              <div class="mb-3" v-if="inscripcion.payment_receipt_uploaded_at">
                <strong>Fecha de carga:</strong>
                <span class="ml-1">{{ formatDate(inscripcion.payment_receipt_uploaded_at) }}</span>
              </div>
              <div class="mb-3" v-if="receiptUrl">
                <v-btn :href="receiptUrl" target="_blank" small color="primary">
                  Ver comprobante
                </v-btn>
              </div>
              <div v-if="isExpired" class="mt-2 red--text text--darken-2 caption">
                La inscripción venció; el comprobante permanecerá en el estado mostrado.
              </div>

            </v-card-text>
          </v-card>

          <v-card v-if="inscripcion && isExpired" outlined class="mb-4 text--darken-2">
            <v-card-text>
              <h2 class="text-h6 mb-3 red--text">Inscripción expirada</h2>
              <p class="body-2 mb-3">
                El plazo para subir el comprobante venció y esta pre‑inscripción fue invalidada
                <span v-if="hasReceipt && inscripcion.state !== 'PAYMENT_REJECTED'"> (se conservará el comprobante
                  enviado).</span>
              </p>
              <div class="grey lighten-4 pa-3 rounded mb-4">
                <strong>Evento: </strong>
                <span>{{ inscripcion.modalidad.evento.nombre }}</span><br>
                <strong>Vencimiento original: </strong>
                <span>{{ formatDate(inscripcion.expires_at) }}</span>
              </div>
              <v-btn color="primary" depressed
                :to="{ name: 'inscripcion', params: { id: inscripcion.modalidad.evento.id } }">
                Volver a inscribirse
              </v-btn>
            </v-card-text>
          </v-card>
          <div class="form-wrapper"  v-if="canUploadReceipt">
            <v-form ref="form" v-model="formValid" @submit.prevent="onSubmit" v-if="canUploadReceipt">
              <p style="margin: 0;">Tiempo para subir comprobante</p>
              <CountDown v-if="countdownTargetDate && !isExpired" :target-date="countdownTargetDate"
              @finished="fetchInscripcion" />
              <v-text-field :value="fileName" :label="`Archivo (imagen o PDF, hasta ${maxSizeMB}MB)`"
              prepend-icon="attach_file" readonly clearable :rules="[fileRequired, fileTypeRule, fileSizeRule]"
              @click:prepend="openPicker" @click="openPicker" @click:clear="clearFile" />
              <input ref="fileInput" type="file" :accept="accepts" class="d-none" @change="onFileChange" />
              <v-img v-if="previewUrl && isImage" :src="previewUrl" max-width="520" max-height="300" contain
              class="mb-3" />
              <v-btn color="primary" type="submit" :loading="uploading" :disabled="!formValid || uploading" large block>
              {{ submitLabel }}
              </v-btn>
            </v-form>
          </div>
          
        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import CountDown from '../../../components/utils/CountDown.vue';
import api from '../../../api/PaymentReceipts';

export default {
  name: 'PaymentReceipts',
  components: {
    CountDown,
  },
  data() {
    return {
      loading: true,
      uploading: false,
      success: false,
      error: null,
      token: null,
      inscripcion: null,
      message: '',
      paymentData: {
        valor: 0,
        costo_servicio: 0,
        total: 0,
        fecha_vencimiento: ''
      },
      file: null,
      fileName: '',
      previewUrl: null,
      formValid: false,
      maxSizeMB: 8,
      accepts: 'image/*,application/pdf',
      baseUrl: process.env.VUE_APP_HOST_URL + '/files/'
    };
  },
  computed: {
    isExpired() {
      if (!this.inscripcion || !this.inscripcion.expires_at) return false;
      return new Date(this.inscripcion.expires_at).getTime() < Date.now();
    },
    isImage() {
      return this.file && this.file.type && this.file.type.startsWith('image/');
    },
    hasReceipt() {
      return !!(
        this.inscripcion &&
        (this.inscripcion.payment_receipt_path || this.inscripcion.payment_receipt_url)
      );
    },
    receiptUrl() {
      if (!this.hasReceipt) return '';
      const path = this.inscripcion.payment_receipt_url;
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      return this.baseUrl + path.replace(/^\/?/, '');
    },
    stateInfo() {
      const s = (this.inscripcion && this.inscripcion.state) || '';
      switch (s) {
        case 'pago_en_revision':
          return { text: 'En revisión', color: 'warning' };
        case 'pago_realizado':
          return { text: 'Aprobado', color: 'success' };
        case 'pago_rechazado':
          return { text: 'Rechazado', color: 'error' };
        case 'pago_pendiente':
          return { text: 'Pendiente', color: 'grey' };
        default:
          return { text: s || 'Desconocido', color: 'grey' };
      }
    },
    showTransferInstructions() {
      return (
        this.inscripcion &&
        this.inscripcion.modalidad &&
        this.inscripcion.modalidad.evento &&
        !this.isExpired &&
        (
          !this.hasReceipt ||
          (this.inscripcion.state === 'pago_pendiente')
        )
      );
    },
    canUploadReceipt() {
      return (
        !this.isExpired &&
        !this.success &&
        (
          !this.hasReceipt ||
          (this.inscripcion && this.inscripcion.state === 'pago_pendiente')
        )
      );
    },
    submitLabel() {
      if (this.hasReceipt && this.inscripcion && this.inscripcion.state === 'pago_pendiente') {
        return 'Volver a subir comprobante';
      }
      return 'Subir comprobante';
    },
    countdownTargetDate() {

      const date = new Date(this.inscripcion.expires_at);
      date.setHours(date.getHours());

      return date;
    }
  },
  async mounted() {
    const token = this.$route.params.token || this.$route.query.token;
    if (!token) {
      this.error = 'Token no encontrado.';
      this.loading = false;
      return;
    }
    this.token = token;
    await this.fetchInscripcion();

  },
  methods: {
    async fetchInscripcion() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await api.getInscripcionByToken(this.token);
        this.inscripcion = data.results.inscription;
        this.paymentData = data.results.payment_ammount_data;
      } catch (e) {
        this.error = 'No se pudo cargar la inscripción. Verificá el enlace.';
      } finally {
        this.loading = false;
      }
    },


    openPicker() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    clearFile() {
      this.file = null;
      this.fileName = '';
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
    },
    onFileChange(e) {
      const f = e.target.files && e.target.files[0];
      this.clearFile();
      if (!f) return;

      this.file = f;
      this.fileName = f.name;

      if (this.isImage) {
        this.previewUrl = URL.createObjectURL(f);
      }
      this.$nextTick(() => this.$refs.form && this.$refs.form.validate());
    },
    fileRequired() {
      return !!this.file || 'Seleccioná un archivo.';
    },
    fileTypeRule() {
      if (!this.file) return true;
      const type = this.file && this.file.type ? this.file.type : '';
      const ok = (type.indexOf('image/') === 0) || type === 'application/pdf';
      return ok || 'Formato no permitido. Usá imagen o PDF.';
    },
    fileSizeRule() {
      if (!this.file) return true;
      const sizeMB = this.file.size / (1024 * 1024);
      return sizeMB <= this.maxSizeMB || `El archivo supera ${this.maxSizeMB}MB.`;
    },
    formatDate(str) {
      if (!str) return '';
      try {
        const d = new Date(str);
        const day = ('0' + d.getDate()).slice(-2);
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      } catch {
        return str;
      }
    },
    async onSubmit() {
      const ok = this.$refs.form && this.$refs.form.validate();
      if (!ok) return;
      this.uploading = true;
      try {
        const form = new FormData();
        form.append('access_token', this.token);
        form.append('receipt_file', this.file);
        const { data } = await api.uploadComprobante(form);
        this.success = true;
        if (data && data.results) {
          this.inscripcion.payment_receipt_path = data.results.file_path;
          this.inscripcion.payment_receipt_url = data.results.payment_receipt_url || data.results.file_url;
          this.inscripcion.state = data.results.state;
          this.inscripcion.payment_receipt_uploaded_at = new Date().toISOString();
        }
      } catch (e) {
        this.error =
          (e.response && e.response.data && e.response.data.message) ||
          'Error al subir el comprobante.';
      } finally {
        this.uploading = false;
      }
    },
  },
  beforeDestroy() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
  },
};
</script>

<style scoped>

.quote-payment-instruction {
  margin: 16px 0;
  padding: 16px 20px;
  border-left: 4px solid #fd9001;
  background-color: #fef7e6;
  border-radius: 4px;
  font-style: italic;
}

.quote-payment-instruction p {
  margin: 0 !important;
  color: #333;
}

.d-none {
  display: none;
}

.red--text {
  color: #b00020 !important;
}
.form-wrapper {
  border: 1px solid #fd9001;
  border-radius: 8px;
  padding: 16px;
  background-color: #fafafa;
}
</style>